/**
 * Compound-tool action telemetry (WP-484 S1, Q3: decided in). Per-tool+action call counter.
 * `runWithToolContext` (client.ts) is already the one chokepoint every compound tool wraps its
 * handler body in (Code Integrity: derive from what the system already tracks, don't add a
 * second call site per tool) — §2 found NO existing per-MCP-tool call-frequency telemetry, so
 * this is what makes the *next* consolidation decision data-driven. In-memory for local/test
 * visibility; mirrored to PostHog (`mcp_compound_tool_action`) separately via `trackCompoundToolAction`.
 *
 * Extracted out of client.ts (not inlined) — STD-2/DEC-1504: client.ts is grandfathered
 * shrink-only; this is the WP-584 offset for that PR's session-start notice type addition.
 */
const toolActionCounts = new Map<string, number>();

function actionCountKey(tool: string, action?: string): string {
  return action ? `${tool}:${action}` : tool;
}

export function recordToolAction(tool: string, action?: string): void {
  const key = actionCountKey(tool, action);
  toolActionCounts.set(key, (toolActionCounts.get(key) ?? 0) + 1);
}

/** Snapshot of per-tool+action call counts for this process (diagnostics/tests). */
export function getToolActionCounts(): Record<string, number> {
  return Object.fromEntries(toolActionCounts);
}

/** Test-only: reset the counter between test cases. */
export function resetToolActionCounts(): void {
  toolActionCounts.clear();
}
